var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNintendo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83858C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.28,2.06c-1.99,0.36-3.6,1.83-4.1,3.77C2,6.53,1.99,6.94,2.01,12.37c0.01,4.99,0.02,5.1,0.1,5.49 c0.46,2.08,1.93,3.55,4.03,4.04c0.27,0.06,0.62,0.07,2.86,0.09c2.32,0.02,2.56,0.01,2.62-0.05c0.06-0.06,0.07-0.86,0.07-9.92 c0-6.72-0.01-9.88-0.04-9.94C11.6,2,11.53,2,9.11,2C7.13,2.01,6.54,2.02,6.28,2.06z M10.03,12v8.39l-1.69-0.02 c-1.55-0.02-1.72-0.02-2.03-0.1c-1.33-0.34-2.32-1.37-2.6-2.71c-0.09-0.42-0.09-10.72,0-11.13C3.96,5.27,4.77,4.3,5.86,3.87 c0.55-0.22,0.8-0.24,2.57-0.25l1.6,0V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.64,6.14C6.38,6.19,5.98,6.39,5.77,6.58C5.33,6.96,5.12,7.49,5.15,8.12C5.17,8.45,5.19,8.53,5.32,8.8 c0.19,0.4,0.49,0.7,0.89,0.89c0.28,0.14,0.35,0.15,0.71,0.17c0.33,0.01,0.44,0,0.66-0.07c0.9-0.3,1.44-1.18,1.29-2.07 C8.69,6.65,7.68,5.94,6.64,6.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,2.03c-0.02,0.01-0.03,4.5-0.03,9.98c0,9.03,0,9.95,0.07,9.97c0.11,0.04,3.33,0.02,3.72-0.02 c1.68-0.19,3.16-1.21,3.97-2.73c0.1-0.19,0.24-0.52,0.31-0.72c0.26-0.78,0.25-0.57,0.25-6.52c0-4.75-0.01-5.46-0.07-5.76 c-0.41-2.16-2.05-3.79-4.22-4.16C17.43,2.01,16.98,2,15.54,2C14.54,2,13.72,2.01,13.7,2.03z M18.13,11.05 c0.65,0.17,1.18,0.66,1.39,1.29c0.14,0.39,0.13,0.96,0,1.32c-0.25,0.65-0.75,1.11-1.39,1.28c-1.04,0.27-2.14-0.36-2.44-1.38 c-0.09-0.31-0.09-0.84,0.02-1.17C16.02,11.38,17.09,10.78,18.13,11.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNintendo);
export default __webpack_public_path__ + "static/media/icon-nintendo.f744ac3aac8dc11c6da891ff17d317b6.svg";
export { ForwardRef as ReactComponent };